export default "__VITE_ASSET__Dpx8$tqo__"